import React, { useEffect, useState } from "react";

export const ErrorModel = (props) => {
  return (
    <div className="modal modalSuccessfull modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <div className="modal__header--logo">
            <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="
                http://www.w3.org/2000/svg">
                <path d="M51.8212 28.9938L28.6837 52.1313M28.6837 28.9938L51.8212 52.1313M78.8149 40.5625C78.8149 61.86 61.5499 79.125 40.2524 79.125C18.955 79.125 1.68994 61.86 1.68994 40.5625C1.68994 19.265 18.955 2 40.2524 2C61.5499 2 78.8149 19.265 78.8149 40.5625Z" stroke="#F56969" stroke-width="2.89" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </div>
          </div>
          <div className="modal__body">
            <h4 className="promptMessage">{props.message} </h4>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
